// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"ba43c438","862":"6554b100"}[chunkId] + ".chunk.js";
};